import { newSpecPage } from '@stencil/core/testing';
import { HappyreactForm } from '../hr-form';

describe('happyreact-form', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [HappyreactForm],
      html: `<happyreact-form></happyreact-form>`,
    });
    expect(page.root).toEqualHtml(`
      <happyreact-form>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </happyreact-form>
    `);
  });
});
